import { render, staticRenderFns } from "./EmptyDashboard.vue?vue&type=template&id=de9e5ae4&"
import script from "./EmptyDashboard.vue?vue&type=script&lang=js&"
export * from "./EmptyDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports